function ListTableColumn(_a) {
    var label = _a.label, property = _a.property, render = _a.render, sortable = _a.sortable, isPlaceholder = _a.isPlaceholder;
    return null;
}
ListTableColumn.displayName = 'ListTableColumn';
export default ListTableColumn;
